(function () {
  "use strict";

  if (!window.theme) window.theme = {};

  theme.CollectionDynamicFilters = (function () {
    var selectors = {
      container: "#CollectionDynamicFilters",
      form: "#CollectionDynamicFiltersForm",
      mobileForm: "#CollectionDynamicFiltersMobileForm",
      mobileTrigger: "#CollectionDynamicFiltersMobileTrigger",
      mobileDrawer: "#CollectionDynamicFiltersMobileDrawer",
      mobileOverlay: "#CollectionDynamicFiltersMobileOverlay",
      mobileClose: "#CollectionDynamicFiltersMobileClose",
      mobileApplyBtn: "#CollectionDynamicFiltersMobileApply",
      mobileClearBtn: "#CollectionDynamicFiltersMobileClear",
      checkbox: ".collection-dynamic-filters__checkbox",
      mobileCheckbox: ".collection-dynamic-filters__mobile-checkbox",
      priceInput: ".collection-dynamic-filters__price-input",
      mobilePriceInput: ".collection-dynamic-filters__mobile-price-input",
      countDisplay: "[data-collection-count]",
    };

    var config = {
      namespace: ".collectionDynamicFilters",
      isAnimating: false,
      debounceTimer: null,
      debounceDelay: 300,
    };

    function getSelector(prefix, suffix, isMobile) {
      return prefix + (isMobile ? "mobile-" : "") + suffix;
    }

    function CollectionDynamicFilters(container) {
      this.container = container;
      if (!this.container) return;

      this.mainSectionId = this.container.dataset.mainSectionId;
      if (!this.mainSectionId) {
        var mainCollectionSection = document.querySelector('[data-section-type="collection-template"]');
        this.mainSectionId = mainCollectionSection ? mainCollectionSection.dataset.sectionId : null;
      }

      this.initAjaxRenderer();
      this.init();
    }

    CollectionDynamicFilters.prototype = {
      init: function () {
        this.bindEvents();
        this.initMobileDrawer();
        this.initActiveFiltersBadges();

        var self = this;
        setTimeout(function () {
          self.adjustStickyPosition();
        }, 100);

        setTimeout(function () {
          self.adjustStickyPosition();
        }, 1000);
      },


      adjustStickyPosition: function () {
        var self = this;
        var filterContainer = document.querySelector('.collection-dynamic-filters');
        var filterBar = document.querySelector('.collection-dynamic-filters__bar');

        if (!filterContainer || !filterBar) {
          setTimeout(function () {
            self.adjustStickyPosition();
          }, 500);
          return;
        }

        var filterInitialTop = null;

        function checkHeaderSticky() {
          var headerWrapper = document.getElementById('HeaderWrapper');
          var headerSection = document.querySelector('.header-section');

          if (!headerWrapper || !headerSection) {
            filterBar.classList.add('is-active');
            return;
          }

          var headerRect = headerSection.getBoundingClientRect();
          var headerHeight = headerWrapper.offsetHeight;

          document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

          if (filterInitialTop === null) {
            filterInitialTop = filterContainer.getBoundingClientRect().top + window.scrollY;
          }

          var isHeaderAtTop = headerRect.top === 0 || (headerRect.top >= -2 && headerRect.top <= 2);
          var hasScroll = window.scrollY > 0;

          if (isHeaderAtTop && hasScroll) {
            filterContainer.classList.add('is-header-sticky');
          } else {
            filterContainer.classList.remove('is-header-sticky');
          }

          var scrollPassedFilter = filterInitialTop !== null && window.scrollY >= (filterInitialTop - headerHeight - 80);

          var hasStickyClass = filterContainer.classList.contains('is-header-sticky');
          if (hasStickyClass && scrollPassedFilter && hasScroll) {
            filterContainer.style.borderBottom = '1px solid #e8e8e1';
          } else {
            filterContainer.style.borderBottom = 'none';
          }

          var scrollThreshold = 100;
          var isHeaderSticky = window.scrollY > scrollThreshold || headerWrapper.classList.contains('header-wrapper--compressed-comnent');
          var isHeaderVisible = headerRect.top >= 0 && headerRect.top < window.innerHeight;

          if (isHeaderSticky && isHeaderVisible) {
            filterBar.classList.add('is-active');
            if (window.scrollY > scrollThreshold + 50) {
              filterBar.classList.add('is-scrolled');
            } else {
              filterBar.classList.remove('is-scrolled');
            }
          } else {
            filterBar.classList.add('is-active');
            filterBar.classList.remove('is-scrolled');
          }
        }

        var parent = filterContainer.parentElement;
        var checkedParents = [];
        while (parent && parent !== document.body && checkedParents.length < 5) {
          var computedStyle = window.getComputedStyle(parent);
          if (computedStyle.overflow === 'hidden' || computedStyle.overflow === 'auto' || computedStyle.overflow === 'scroll') {
            parent.style.setProperty('overflow', 'visible', 'important');
          }
          checkedParents.push(parent);
          parent = parent.parentElement;
        }

        checkHeaderSticky();

        var scrollHandler = theme.utils ? theme.utils.debounce(50, checkHeaderSticky) : function () {
          setTimeout(checkHeaderSticky, 50);
        };
        window.addEventListener('scroll', scrollHandler, { passive: true });

        var debouncedCalculate = theme.utils ? theme.utils.debounce(300, checkHeaderSticky) : function () {
          setTimeout(checkHeaderSticky, 300);
        };
        window.addEventListener('resize', debouncedCalculate);

        if (window.MutationObserver) {
          var headerObserver = new MutationObserver(checkHeaderSticky);
          var headerElement = document.getElementById('HeaderWrapper');
          if (headerElement) {
            headerObserver.observe(headerElement, {
              attributes: true,
              attributeFilter: ['class', 'style'],
              childList: false,
              subtree: false
            });
          }
        }
      },

      initAjaxRenderer: function () {
        if (!window.theme.AjaxRenderer) {
          return;
        }

        if (!this.mainSectionId) {
          var mainCollectionSection = document.querySelector('[data-section-type="collection-template"]');
          this.mainSectionId = mainCollectionSection ? mainCollectionSection.dataset.sectionId : null;
        }

        if (!this.mainSectionId) {
          return;
        }

        this.ajaxRenderer = new theme.AjaxRenderer({
          sections: [{ sectionId: this.mainSectionId, nodeId: "CollectionAjaxContent" }],
          onReplace: this.onReplaceContent.bind(this),
        });
      },

      bindEvents: function () {
        var self = this;
        this.initFilterDropdowns();

        [selectors.form, selectors.mobileForm].forEach(function (formSelector) {
          var form = document.querySelector(formSelector);
          if (!form) return;

          form.removeEventListener("change", self.handleCheckboxChange);
          form.addEventListener("change", self.handleCheckboxChange.bind(self), true);
          form.removeEventListener("click", self.handleLabelClick);
          form.addEventListener("click", self.handleLabelClick.bind(self), true);

          var checkboxes = form.querySelectorAll('input[type="checkbox"]');
          var boundHandler = self.handleCheckboxChange.bind(self);
          checkboxes.forEach(function (checkbox) {
            if (!checkbox.dataset.wasChecked) checkbox.dataset.wasChecked = checkbox.checked;
            checkbox.addEventListener("change", boundHandler);
          });
        });

        this.initPriceRangeHandlers(false);
        this.initPriceRangeHandlers(true);
        this.initPriceRangeButtons(false);
        this.initPriceRangeButtons(true);

        // SEMPRE remover listeners antigos e re-anexar (elementos podem ter sido recriados)
        var mobileApplyBtn = document.querySelector(selectors.mobileApplyBtn);
        if (mobileApplyBtn) {
          // Remover listener antigo se existir
          var newApplyBtn = mobileApplyBtn.cloneNode(true);
          mobileApplyBtn.parentNode.replaceChild(newApplyBtn, mobileApplyBtn);

          newApplyBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            self.applyMobileFilters();
          }, true);
        }

        var mobileClearBtn = document.querySelector(selectors.mobileClearBtn);
        if (mobileClearBtn) {
          // Remover listener antigo se existir
          var newClearBtn = mobileClearBtn.cloneNode(true);
          mobileClearBtn.parentNode.replaceChild(newClearBtn, mobileClearBtn);

          newClearBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            self.clearAllFilters();
          }, true);
        }

        var clearAllBtn = document.getElementById("CollectionClearAllFilters");
        if (clearAllBtn) {
          clearAllBtn.addEventListener("click", function (e) {
            e.preventDefault();
            self.clearAllFilters();
          });
        }
      },

      initPriceRangeHandlers: function (isMobile) {
        var self = this;
        var checkboxSelector = getSelector(".collection-dynamic-filters__", "price-range-checkbox", isMobile);
        var inputSelector = getSelector(".collection-dynamic-filters__", "price-input", isMobile);
        var priceRangeSelector = getSelector(".collection-dynamic-filters__", "price-range", isMobile);

        var checkboxes = document.querySelectorAll(checkboxSelector);
        checkboxes.forEach(function (checkbox) {
          checkbox.addEventListener("change", function () {
            self.handlePriceRangeCheckboxChange(checkbox, isMobile);
          });
        });

        var inputs = document.querySelectorAll(inputSelector);
        inputs.forEach(function (input) {
          input.addEventListener("input", function () {
            input.removeAttribute("data-empty");
            var priceRangeEl = input.closest(priceRangeSelector);
            var filterId = priceRangeEl ? priceRangeEl.dataset.filterId : null;
            if (filterId) {
              var priceRange = document.querySelector(priceRangeSelector + '[data-filter-id="' + filterId + '"]');
              if (priceRange) {
                var checkboxes = priceRange.querySelectorAll(checkboxSelector);
                checkboxes.forEach(function (cb) {
                  cb.checked = false;
                  var label = cb.closest(getSelector(".collection-dynamic-filters__", "price-range-option", isMobile));
                  if (label) label.classList.remove("is-active");
                });
                self.updatePriceRangeSelectedCount(filterId, isMobile);
              }
            }
          });
        });
      },

      handlePriceRangeCheckboxChange: function (checkbox, isMobile) {
        var filterId = checkbox.dataset.filterId;
        var priceMin = parseFloat(checkbox.dataset.priceMin);
        var priceMax = parseFloat(checkbox.dataset.priceMax);
        var label = checkbox.closest(getSelector(".collection-dynamic-filters__", "price-range-option", isMobile));
        var prefix = getSelector(".collection-dynamic-filters__", "price-range", isMobile);
        var priceRange = document.querySelector(prefix + '[data-filter-id="' + filterId + '"]');

        if (checkbox.checked) {
          if (label) label.classList.add("is-active");

          var otherCheckboxes = document.querySelectorAll(
            prefix + '[data-filter-id="' + filterId + '"] .collection-dynamic-filters__' + (isMobile ? "mobile-" : "") + "price-range-checkbox"
          );
          otherCheckboxes.forEach(function (cb) {
            if (cb !== checkbox) {
              cb.checked = false;
              var otherLabel = cb.closest(getSelector(".collection-dynamic-filters__", "price-range-option", isMobile));
              if (otherLabel) otherLabel.classList.remove("is-active");
            }
          });

          if (priceRange) {
            var minInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--min", isMobile));
            var maxInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--max", isMobile));

            if (minInput) {
              if (priceMin === 0 || priceMin <= 0) {
                minInput.value = "";
                minInput.removeAttribute("value");
                minInput.setAttribute("data-empty", "true");
              } else {
                minInput.value = priceMin;
                minInput.removeAttribute("data-empty");
              }
            }
            if (maxInput) {
              if (priceMax === 999999999 || priceMax >= 999999 || priceMax <= 0) {
                maxInput.value = "";
                maxInput.removeAttribute("value");
                maxInput.setAttribute("data-empty", "true");
              } else {
                maxInput.value = priceMax;
                maxInput.removeAttribute("data-empty");
              }
            }
          }
        } else {
          if (label) label.classList.remove("is-active");
          if (priceRange) {
            var minInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--min", isMobile));
            var maxInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--max", isMobile));
            if (minInput) minInput.value = "";
            if (maxInput) maxInput.value = "";
          }
        }

        this.updatePriceRangeSelectedCount(filterId, isMobile);
      },

      initPriceRangeButtons: function (isMobile) {
        var self = this;
        var applySelector = getSelector(".collection-dynamic-filters__", "price-apply-btn", isMobile);
        var clearSelector = getSelector(".collection-dynamic-filters__", "price-clear-btn", isMobile);

        var applyButtons = document.querySelectorAll(applySelector);
        applyButtons.forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            var filterId = btn.dataset.filterId;
            if (isMobile) {
              self.updatePriceRangeSelectedCount(filterId, true);
            } else {
              self.applyPriceFilter(filterId, false);
            }
          });
        });

        var clearButtons = document.querySelectorAll(clearSelector);
        clearButtons.forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            var filterId = btn.dataset.filterId;
            if (isMobile) {
              self.clearPriceFilterValues(filterId, true);
            } else {
              self.clearPriceFilter(filterId, false);
            }
          });
        });
      },

      applyPriceFilter: function (filterId, isMobile) {
        if (isMobile) {
          this.updatePriceRangeSelectedCount(filterId, true);
          return;
        }

        var prefix = getSelector(".collection-dynamic-filters__", "price-range", isMobile);
        var priceRange = document.querySelector(prefix + '[data-filter-id="' + filterId + '"]');
        if (!priceRange) return;

        var filterGroup = priceRange.closest(".collection-dynamic-filters__filter-group");
        if (filterGroup && filterGroup.classList.contains("is-open")) {
          if (!this.savedOpenDropdowns) this.savedOpenDropdowns = [];
          if (this.savedOpenDropdowns.indexOf(filterId) === -1) this.savedOpenDropdowns.push(filterId);
        }

        this.handleFilterChange();
      },

      clearPriceFilterValues: function (filterId, isMobile) {
        var prefix = getSelector(".collection-dynamic-filters__", "price-range", isMobile);
        var priceRange = document.querySelector(prefix + '[data-filter-id="' + filterId + '"]');
        if (!priceRange) return;

        var minInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--min", isMobile));
        var maxInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--max", isMobile));
        if (minInput) minInput.value = "";
        if (maxInput) maxInput.value = "";

        var checkboxes = priceRange.querySelectorAll(getSelector(".collection-dynamic-filters__", "price-range-checkbox", isMobile));
        checkboxes.forEach(function (checkbox) {
          checkbox.checked = false;
          var label = checkbox.closest(getSelector(".collection-dynamic-filters__", "price-range-option", isMobile));
          if (label) label.classList.remove("is-active");
        });

        this.updatePriceRangeSelectedCount(filterId, isMobile);
        if (!isMobile) this.handleFilterChange();
      },

      clearPriceFilter: function (filterId, isMobile) {
        var self = this;
        var desktopPriceRange = document.querySelector('.collection-dynamic-filters__price-range[data-filter-id="' + filterId + '"]');
        var mobilePriceRange = document.querySelector('.collection-dynamic-filters__mobile-price-range[data-filter-id="' + filterId + '"]');

        [desktopPriceRange, mobilePriceRange].forEach(function (priceRange) {
          if (!priceRange) return;
          var isMobileRange = priceRange.classList.contains("mobile-price-range");
          var minInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--min", isMobileRange));
          var maxInput = priceRange.querySelector("." + getSelector("collection-dynamic-filters__", "price-input--max", isMobileRange));
          if (minInput) minInput.value = "";
          if (maxInput) maxInput.value = "";

          var checkboxes = priceRange.querySelectorAll(getSelector(".collection-dynamic-filters__", "price-range-checkbox", isMobileRange));
          checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
            var label = checkbox.closest(getSelector(".collection-dynamic-filters__", "price-range-option", isMobileRange));
            if (label) label.classList.remove("is-active");
          });
        });

        this.updatePriceRangeSelectedCount(filterId, false);
        this.updatePriceRangeSelectedCount(filterId, true);

        setTimeout(function () {
          var priceParamNames = [];
          if (desktopPriceRange) {
            var desktopMinInput = desktopPriceRange.querySelector(".collection-dynamic-filters__price-input--min");
            var desktopMaxInput = desktopPriceRange.querySelector(".collection-dynamic-filters__price-input--max");
            if (desktopMinInput && desktopMinInput.name) priceParamNames.push(desktopMinInput.name);
            if (desktopMaxInput && desktopMaxInput.name) priceParamNames.push(desktopMaxInput.name);
          }

          var formData = self.getFormData();
          var newSearchParams = new URLSearchParams();
          var currentUrl = new URL(window.location.href);
          var sortBy = currentUrl.searchParams.get("sort_by");

          if (sortBy) newSearchParams.set("sort_by", sortBy);

          for (var pair of formData.entries()) {
            var key = pair[0];
            if (priceParamNames.indexOf(key) === -1) newSearchParams.append(key, pair[1]);
          }

          var newFormData = new FormData();
          for (var pair of newSearchParams.entries()) newFormData.append(pair[0], pair[1]);

          self.renderCollectionPage(newFormData);

          setTimeout(function () {
            var finalUrl = window.location.pathname;
            if (newSearchParams.toString()) finalUrl += "?" + newSearchParams.toString();
            window.history.replaceState({}, "", finalUrl);
          }, 150);
        }, 50);
      },

      updatePriceRangeSelectedCount: function (filterId, isMobile) {
        var prefix = getSelector(".collection-dynamic-filters__", "price-range", isMobile);
        var priceRange = document.querySelector(prefix + '[data-filter-id="' + filterId + '"]');
        if (!priceRange) return;

        var checkboxes = priceRange.querySelectorAll(getSelector(".collection-dynamic-filters__", "price-range-checkbox", isMobile));
        var checkedCount = 0;

        checkboxes.forEach(function (checkbox) {
          var label = checkbox.closest(getSelector(".collection-dynamic-filters__", "price-range-option", isMobile));
          if (checkbox.checked) {
            checkedCount++;
            if (label) label.classList.add("is-active");
          } else {
            if (label) label.classList.remove("is-active");
          }
        });

        var countElement = document.querySelector('[data-price-selected-count="' + filterId + '"]');
        if (countElement) countElement.textContent = checkedCount;
      },

      handleCheckboxChange: function (e) {
        var checkbox = e.target;
        var isMobile = checkbox.classList.contains("collection-dynamic-filters__mobile-checkbox");

        if (
          checkbox.type === "checkbox" &&
          (checkbox.classList.contains("collection-dynamic-filters__checkbox") || isMobile)
        ) {
          var currentState = checkbox.checked;
          checkbox.dataset.userState = currentState ? "checked" : "unchecked";
          checkbox.dataset.wasChecked = currentState;

          var label = checkbox.closest("label");
          if (label) {
            if (checkbox.checked) label.classList.add("is-active");
            else label.classList.remove("is-active");
          }

          this.updateSelectedCount(checkbox);
          if (!isMobile) this.handleFilterChange();
        }
      },

      handleLabelClick: function (e) {
        if (e.target.type === "checkbox") return;

        var label = e.target.closest("label.collection-dynamic-filters__option, label.collection-dynamic-filters__mobile-option");
        if (!label) return;

        var checkbox = label.querySelector('input[type="checkbox"]');
        if (!checkbox) return;

        var self = this;
        setTimeout(function () {
          checkbox.dispatchEvent(new Event("change", { bubbles: true, cancelable: true }));
        }, 10);
      },

      initFilterDropdowns: function () {
        var self = this;

        if (this.filterDropdownClickHandler) document.removeEventListener("click", this.filterDropdownClickHandler);

        var form = document.querySelector(selectors.form);
        if (!form) return;

        if (this.filterDropdownDelegateHandler) form.removeEventListener("click", this.filterDropdownDelegateHandler);

        this.filterDropdownDelegateHandler = function (e) {
          var trigger = e.target.closest(".collection-dynamic-filters__filter-trigger");
          if (trigger) {
            e.stopPropagation();
            var filterGroup = trigger.closest(".collection-dynamic-filters__filter-group");
            if (filterGroup) self.toggleFilterDropdown(filterGroup, trigger);
          }
        };

        form.addEventListener("click", this.filterDropdownDelegateHandler);

        this.filterDropdownClickHandler = function (e) {
          if (!e.target.closest(".collection-dynamic-filters__filter-group")) {
            var openGroups = document.querySelectorAll(".collection-dynamic-filters__filter-group.is-open");
            openGroups.forEach(function (group) {
              var trigger = group.querySelector(".collection-dynamic-filters__filter-trigger");
              if (trigger) self.closeFilterDropdown(group, trigger);
            });
          }
        };

        document.addEventListener("click", this.filterDropdownClickHandler);
      },

      toggleFilterDropdown: function (filterGroup, trigger) {
        if (filterGroup.classList.contains("is-open")) this.closeFilterDropdown(filterGroup, trigger);
        else this.openFilterDropdown(filterGroup, trigger);
      },

      openFilterDropdown: function (filterGroup, trigger) {
        var openGroups = document.querySelectorAll(".collection-dynamic-filters__filter-group.is-open");
        openGroups.forEach(function (group) {
          if (group !== filterGroup) {
            var otherTrigger = group.querySelector(".collection-dynamic-filters__filter-trigger");
            if (otherTrigger) {
              group.classList.remove("is-open");
              otherTrigger.setAttribute("aria-expanded", "false");
            }
          }
        });

        filterGroup.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      },

      closeFilterDropdown: function (filterGroup, trigger) {
        filterGroup.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      },

      updateSelectedCount: function (checkbox) {
        var filterGroup = checkbox.closest(".collection-dynamic-filters__filter-group");
        if (!filterGroup) return;

        var filterId = filterGroup.dataset.filterId;
        var countElement = document.querySelector('[data-selected-count="' + filterId + '"]');
        if (!countElement) return;

        var checkboxes = filterGroup.querySelectorAll(".collection-dynamic-filters__checkbox:checked");
        var count = checkboxes.length;
        countElement.textContent = count;

        var trigger = filterGroup.querySelector(".collection-dynamic-filters__filter-trigger");
        if (trigger) {
          if (count > 0) {
            trigger.classList.add("has-active");
            var countBadge = trigger.querySelector(".collection-dynamic-filters__filter-count");
            if (!countBadge) {
              countBadge = document.createElement("span");
              countBadge.className = "collection-dynamic-filters__filter-count";
              trigger.appendChild(countBadge);
            }
            countBadge.textContent = "(" + count + ")";
          } else {
            trigger.classList.remove("has-active");
            var countBadge = trigger.querySelector(".collection-dynamic-filters__filter-count");
            if (countBadge) countBadge.remove();
          }
        }
      },

      // ============================================

      initMobileDrawer: function () {
        var self = this;

        if (!this.mobileDrawerHandlers) {
          this.mobileDrawerHandlers = {
            triggerClick: function (e) {
              var trigger = e.target.closest(selectors.mobileTrigger);
              if (!trigger) return;

              e.preventDefault();
              e.stopPropagation();

              if (window.collectionDynamicFiltersJustApplied) return;

              self.openMobileDrawer();
            },

            closeClick: function (e) {
              var closeBtn = e.target.closest(selectors.mobileClose);
              if (!closeBtn) return;

              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              self.closeMobileDrawer();
              return false;
            },

            overlayClick: function (e) {
              var overlay = e.target.closest(selectors.mobileOverlay);
              if (!overlay || !overlay.classList.contains("is-active")) return;

              var drawer = document.querySelector(selectors.mobileDrawer);
              if (drawer && drawer.contains(e.target)) return;

              e.preventDefault();
              e.stopPropagation();

              self.closeMobileDrawer();
            },

            applyClick: function (e) {
              var applyBtn = e.target.closest(selectors.mobileApplyBtn);
              if (!applyBtn) return;

              e.preventDefault();
              e.stopPropagation();

              self.applyMobileFilters();
            },

            clearClick: function (e) {
              var clearBtn = e.target.closest(selectors.mobileClearBtn);
              if (!clearBtn) return;

              e.preventDefault();
              e.stopPropagation();

              self.clearAllFilters();
            },

            escapeKey: function (e) {
              if (e.key === "Escape" || e.keyCode === 27) {
                var drawer = document.querySelector(selectors.mobileDrawer);
                if (drawer && drawer.classList.contains("is-open")) {
                  e.preventDefault();
                  self.closeMobileDrawer();
                }
              }
            }
          };
        }

        document.removeEventListener("click", this.mobileDrawerHandlers.triggerClick, true);
        document.removeEventListener("click", this.mobileDrawerHandlers.closeClick, true);
        document.removeEventListener("click", this.mobileDrawerHandlers.overlayClick, true);
        document.removeEventListener("click", this.mobileDrawerHandlers.applyClick, true);
        document.removeEventListener("click", this.mobileDrawerHandlers.clearClick, true);
        document.removeEventListener("keydown", this.mobileDrawerHandlers.escapeKey, true);

        document.addEventListener("click", this.mobileDrawerHandlers.triggerClick, true);
        document.addEventListener("click", this.mobileDrawerHandlers.closeClick, true);
        document.addEventListener("click", this.mobileDrawerHandlers.overlayClick, true);
        document.addEventListener("click", this.mobileDrawerHandlers.applyClick, true);
        document.addEventListener("click", this.mobileDrawerHandlers.clearClick, true);
        document.addEventListener("keydown", this.mobileDrawerHandlers.escapeKey, true);
      },

      openMobileDrawer: function () {
        var drawer = document.querySelector(selectors.mobileDrawer);
        var overlay = document.querySelector(selectors.mobileOverlay);
        var trigger = document.querySelector(selectors.mobileTrigger);

        if (!drawer || !overlay) {
          console.warn('[CollectionFilters] Drawer ou overlay não encontrado no DOM');
          return;
        }

        console.log('[CollectionFilters] Abrindo drawer...');

        if (drawer.parentElement !== document.body) {
          console.log('[CollectionFilters] Movendo drawer para body');
          document.body.appendChild(drawer);
        }
        if (overlay.parentElement !== document.body) {
          console.log('[CollectionFilters] Movendo overlay para body');
          document.body.appendChild(overlay);
        }

        drawer.classList.remove("is-closed");
        overlay.classList.remove("is-closed");

        if (drawer.style.left === "-100%") drawer.style.left = "";
        if (drawer.style.visibility === "hidden") drawer.style.visibility = "";
        if (drawer.style.pointerEvents === "none") drawer.style.pointerEvents = "";

        if (overlay.style.opacity === "0") overlay.style.opacity = "";
        if (overlay.style.visibility === "hidden") overlay.style.visibility = "";
        if (overlay.style.pointerEvents === "none") overlay.style.pointerEvents = "";

        requestAnimationFrame(function () {
          var freshDrawer = document.querySelector(selectors.mobileDrawer);
          var freshOverlay = document.querySelector(selectors.mobileOverlay);
          var freshTrigger = document.querySelector(selectors.mobileTrigger);

          if (!freshDrawer || !freshOverlay) {
            console.warn('[CollectionFilters] Elementos removidos do DOM antes de abrir');
            return;
          }

          freshDrawer.classList.add("is-open");
          freshOverlay.classList.add("is-active");
          if (freshTrigger) freshTrigger.classList.add("is-active");
          document.body.style.overflow = "hidden";

          console.log('[CollectionFilters] Drawer aberto e posicionado acima de tudo');
        });
      },

      closeMobileDrawer: function () {
        var drawer = document.querySelector(selectors.mobileDrawer);
        var overlay = document.querySelector(selectors.mobileOverlay);
        var trigger = document.querySelector(selectors.mobileTrigger);

        console.log('[CollectionFilters] Fechando drawer... Elementos encontrados:', {
          drawer: !!drawer,
          overlay: !!overlay,
          trigger: !!trigger
        });

        if (drawer) {
          drawer.classList.remove("is-open");
          drawer.classList.add("is-closed");
          drawer.style.left = "-100%";
          drawer.style.visibility = "hidden";
          drawer.style.pointerEvents = "none";
        }

        if (overlay) {
          overlay.classList.remove("is-active");
          overlay.classList.add("is-closed");
          overlay.style.opacity = "0";
          overlay.style.visibility = "hidden";
          overlay.style.pointerEvents = "none";
        }

        if (trigger) {
          trigger.classList.remove("is-active");
        }

        document.body.style.overflow = "";

        console.log('[CollectionFilters] Drawer fechado');
      },

      handleFilterChange: function () {
        if (config.isAnimating) return;

        var formData = this.getFormData();
        var hasAnyFilters = false;
        for (var pair of formData.entries()) {
          if (pair[0].startsWith("filter.")) {
            hasAnyFilters = true;
            break;
          }
        }

        if (!hasAnyFilters) {
          var emptyFormData = new FormData();
          var currentUrl = new URL(window.location.href);
          var sortBy = currentUrl.searchParams.get("sort_by");
          if (sortBy) emptyFormData.append("sort_by", sortBy);
          this.renderCollectionPage(emptyFormData);
          return;
        }

        this.renderCollectionPage(formData);
      },

      getFormData: function () {
        var formData = new FormData();
        var allCheckboxes = document.querySelectorAll(selectors.checkbox + ", " + selectors.mobileCheckbox);
        var checkboxStates = {};

        allCheckboxes.forEach(function (checkbox) {
          var key = checkbox.name + "::" + checkbox.value;
          var hasUserState = checkbox.dataset.userState !== undefined && checkbox.dataset.userState !== "";

          if (checkboxStates.hasOwnProperty(key) && !hasUserState) return;

          if (checkbox.dataset.userState === "unchecked") checkboxStates[key] = false;
          else if (checkbox.dataset.userState === "checked") checkboxStates[key] = true;
          else checkboxStates[key] = checkbox.checked;
        });

        Object.keys(checkboxStates).forEach(function (key) {
          if (checkboxStates[key]) {
            var parts = key.split("::");
            formData.append(parts[0], parts.slice(1).join("::"));
          }
        });

        [selectors.form, selectors.mobileForm].forEach(function (formSelector) {
          var form = document.querySelector(formSelector);
          if (!form) return;

          var priceInputs = form.querySelectorAll('input[type="number"]');
          priceInputs.forEach(function (input) {
            if (input.hasAttribute("data-empty") && input.getAttribute("data-empty") === "true") return;
            if (formSelector === selectors.mobileForm && formData.has(input.name)) return;

            var value = input.value ? input.value.trim() : "";
            if (value !== "" && value !== "0" && value !== null && value !== undefined) {
              var numValue = parseFloat(value);
              if (!isNaN(numValue) && numValue > 0) formData.append(input.name, value);
            }
          });
        });

        return formData;
      },

      renderCollectionPage: function (formData, shouldScroll) {
        if (config.isAnimating) return;
        config.isAnimating = true;

        if (typeof shouldScroll === 'undefined') {
          shouldScroll = true;
        }

        this.showLoading();

        var searchParams = new URLSearchParams(formData);
        var self = this;
        var pendingCheckboxStates = {};
        var allCheckboxes = document.querySelectorAll(selectors.checkbox + ", " + selectors.mobileCheckbox);

        allCheckboxes.forEach(function (checkbox) {
          if (checkbox.dataset.userState) {
            var key = checkbox.name + "::" + checkbox.value;
            pendingCheckboxStates[key] = checkbox.dataset.userState === "checked";
          }
        });

        this.pendingCheckboxStates = pendingCheckboxStates;

        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, true)
          .then(function () {
            self.hideLoading();

            if (shouldScroll) {
              self.updateScroll();
            }

            setTimeout(function () {
              self.closeMobileDrawer();

              self.reinit();
              config.isAnimating = false;

              setTimeout(function () {
                self.closeMobileDrawer();
              }, 50);
            }, 100);

            document.dispatchEvent(
              new CustomEvent("collection:filtered", {
                detail: { searchParams: searchParams },
              })
            );
          })
          .catch(function (error) {
            self.hideLoading();
            config.isAnimating = false;
          });
      },

      removeFilterBadge: function (badge) {
        if (!badge) return;

        var paramName = badge.dataset.filterParam;
        var filterValue = badge.dataset.filterValue;
        var checkboxes = document.querySelectorAll('input[type="checkbox"][name="' + paramName + '"][value="' + filterValue + '"]');

        checkboxes.forEach(function (checkbox) {
          checkbox.checked = false;
        });

        if (paramName.includes("filter.v.price")) {
          var priceInputs = document.querySelectorAll('input[name="' + paramName + '"]');
          priceInputs.forEach(function (input) {
            input.value = "";
          });
        }

        this.handleFilterChange();
      },

      applyMobileFilters: function () {
          this.closeMobileDrawer();

        window.collectionDynamicFiltersJustApplied = true;

        this.handleFilterChange();

        var self = this;
        setTimeout(function () {
          window.collectionDynamicFiltersJustApplied = false;
          self.closeMobileDrawer();
        }, 1000);
      },

      clearAllFilters: function () {
        var allCheckboxes = document.querySelectorAll(selectors.checkbox + ", " + selectors.mobileCheckbox);
        allCheckboxes.forEach(function (checkbox) {
          checkbox.checked = false;
          delete checkbox.dataset.userState;
        });

        var allPriceInputs = document.querySelectorAll(selectors.priceInput + ", " + selectors.mobilePriceInput);
        allPriceInputs.forEach(function (input) {
          input.value = "";
        });

        this.closeMobileDrawer();

        var emptyFormData = new FormData();
        var currentUrl = new URL(window.location.href);
        var sortBy = currentUrl.searchParams.get("sort_by");
        if (sortBy) emptyFormData.append("sort_by", sortBy);
        this.renderCollectionPage(emptyFormData);
      },

      showLoading: function () {
        var content = document.querySelector("#CollectionAjaxContent");
        if (content) content.classList.add("is-loading");
      },

      hideLoading: function () {
        var content = document.querySelector("#CollectionAjaxContent");
        if (content) content.classList.remove("is-loading");
      },

      updateScroll: function () {
        var scrollTo = 0;
        var filtersBar = document.querySelector(".collection-dynamic-filters__bar");

        if (filtersBar && window.innerWidth >= 769) {
          scrollTo = filtersBar.offsetTop;
          if (theme.config && theme.config.stickyHeader) {
            var header = document.querySelector("#SiteHeader");
            if (header) scrollTo = scrollTo - header.offsetHeight;
          }
        }

        if (scrollTo > 0) window.scrollTo({ top: scrollTo, behavior: "smooth" });
      },

      onReplaceContent: function (newDom, section) {
        var self = this;

        this.closeMobileDrawer();

        var allDrawers = document.querySelectorAll(selectors.mobileDrawer);
        var allOverlays = document.querySelectorAll(selectors.mobileOverlay);

        console.log('[CollectionFilters] Limpando drawers duplicados...', {
          drawers: allDrawers.length,
          overlays: allOverlays.length
        });

        allDrawers.forEach(function (drawer) {
          if (drawer && drawer.parentElement) {
            drawer.remove();
          }
        });

        allOverlays.forEach(function (overlay) {
          if (overlay && overlay.parentElement) {
            overlay.remove();
          }
        });

        console.log('[CollectionFilters] Drawers duplicados removidos');

        if (section.nodeId === "CollectionAjaxContent") {
          var newContentEl = newDom.getElementById(section.nodeId);
          if (newContentEl) {
            var currentContent = document.getElementById(section.nodeId);
            if (currentContent) {
              currentContent.innerHTML = newContentEl.innerHTML;

              var updatedFiltersContainer = document.getElementById("CollectionDynamicFilters");
              if (updatedFiltersContainer) self.container = updatedFiltersContainer;

              if (self.pendingCheckboxStates) {
                setTimeout(function () {
                  var allNewCheckboxes = document.querySelectorAll(selectors.checkbox + ", " + selectors.mobileCheckbox);
                  allNewCheckboxes.forEach(function (checkbox) {
                    var key = checkbox.name + "::" + checkbox.value;
                    if (self.pendingCheckboxStates.hasOwnProperty(key)) {
                      var userState = self.pendingCheckboxStates[key];
                      checkbox.checked = userState;
                      var label = checkbox.closest("label");
                      if (label) {
                        if (userState) label.classList.add("is-active");
                        else label.classList.remove("is-active");
                      }
                    }
                  });
                  self.pendingCheckboxStates = null;
                }, 0);
              }
            }
          }
        }

        var countEl = newDom.querySelector("[data-collection-count]");
        if (!countEl) {
          var gridCount = newDom.querySelector(".collection-filter__item--count");
          if (gridCount) {
            var countText = gridCount.textContent.trim();
            var countMatch = countText.match(/(\d+)/);
            if (countMatch) countEl = { textContent: countMatch[1] };
          }
        }

        if (countEl) {
          var count = countEl.textContent.trim();
          var countDisplays = document.querySelectorAll(selectors.countDisplay);
          countDisplays.forEach(function (display) {
            display.textContent = count;
          });
        }

        this.updateActiveFiltersBadges(newDom);

        self.closeMobileDrawer();
        setTimeout(function () {
          self.reinit();
        }, 100);
      },

      reinit: function () {
        var self = this;

        this.closeMobileDrawer();

        this.bindEvents();
        this.initMobileDrawer();
        this.adjustStickyPosition();

        setTimeout(function () {
          self.closeMobileDrawer();
        }, 50);

        if (this.savedOpenDropdowns) {
          var self = this;
          setTimeout(function () {
            self.savedOpenDropdowns.forEach(function (filterId) {
              var filterGroup = document.querySelector('.collection-dynamic-filters__filter-group[data-filter-id="' + filterId + '"]');
              if (filterGroup) {
                var trigger = filterGroup.querySelector(".collection-dynamic-filters__filter-trigger");
                if (trigger) self.openFilterDropdown(filterGroup, trigger);
              }
            });
            self.savedOpenDropdowns = null;
          }, 150);
        }

        var self = this;
        setTimeout(function () {
          self.updateAllSelectedCounts();
          self.initActiveFiltersBadges();
        }, 50);

        if (window.theme && window.theme.reinitProductGridItem) window.theme.reinitProductGridItem();
        if (window.theme && window.theme.sections && window.theme.sections.reinit) {
          window.theme.sections.reinit("collection-template");
        }
      },

      updateAllSelectedCounts: function () {
        var self = this;
        var filterGroups = document.querySelectorAll(".collection-dynamic-filters__filter-group");

        filterGroups.forEach(function (group) {
          var checkboxes = group.querySelectorAll(".collection-dynamic-filters__checkbox:checked");
          var filterId = group.dataset.filterId;
          var count = checkboxes.length;

          var countElement = document.querySelector('[data-selected-count="' + filterId + '"]');
          if (countElement) countElement.textContent = count;

          var trigger = group.querySelector(".collection-dynamic-filters__filter-trigger");
          if (trigger) {
            if (count > 0) {
              trigger.classList.add("has-active");
              var countBadge = trigger.querySelector(".collection-dynamic-filters__filter-count");
              if (!countBadge) {
                countBadge = document.createElement("span");
                countBadge.className = "collection-dynamic-filters__filter-count";
                var labelText = trigger.querySelector(".collection-dynamic-filters__filter-label-text");
                if (labelText && labelText.nextSibling) {
                  trigger.insertBefore(countBadge, labelText.nextSibling);
                } else {
                  trigger.appendChild(countBadge);
                }
              }
              countBadge.textContent = "(" + count + ")";
            } else {
              trigger.classList.remove("has-active");
              var countBadge = trigger.querySelector(".collection-dynamic-filters__filter-count");
              if (countBadge) countBadge.remove();
            }
          }
        });

        [false, true].forEach(function (isMobile) {
          var priceRanges = document.querySelectorAll(
            getSelector(".collection-dynamic-filters__", "price-range[data-filter-id]", isMobile)
          );
          priceRanges.forEach(function (priceRange) {
            var filterId = priceRange.dataset.filterId;
            self.updatePriceRangeSelectedCount(filterId, isMobile);
          });
        });
      },

      initActiveFiltersBadges: function () {
        this.updateActiveFiltersBadges(document);
      },

      updateActiveFiltersBadges: function (newDom) {
        var self = this;
        var activeFiltersContainer = document.getElementById("CollectionActiveFilters");
        if (!activeFiltersContainer) return;

        var newActiveFilters = newDom && newDom !== document ? newDom.getElementById("CollectionActiveFilters") : document.getElementById("CollectionActiveFilters");

        if (newActiveFilters && newActiveFilters !== activeFiltersContainer) {
          activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
        }

        var badges = activeFiltersContainer.querySelectorAll(".collection-dynamic-filters__active-badge");
        var clearAllBtn = document.getElementById("CollectionClearAllFilters");

        if (badges.length > 2) {
          if (!clearAllBtn) {
            clearAllBtn = document.createElement("button");
            clearAllBtn.type = "button";
            clearAllBtn.className = "collection-dynamic-filters__clear-all-btn";
            clearAllBtn.id = "CollectionClearAllFilters";
            clearAllBtn.setAttribute("aria-label", "Limpar todos os filtros");
            clearAllBtn.textContent = "Limpar Filtros";
            activeFiltersContainer.appendChild(clearAllBtn);
          }
        } else if (clearAllBtn) {
          clearAllBtn.remove();
        }

        if (clearAllBtn) {
          var newClearBtn = clearAllBtn.cloneNode(true);
          clearAllBtn.parentNode.replaceChild(newClearBtn, clearAllBtn);
          newClearBtn.addEventListener("click", function (e) {
            e.preventDefault();
            self.clearAllFilters();
          });
        }

        var removeButtons = activeFiltersContainer.querySelectorAll(".collection-dynamic-filters__active-badge-remove");

        removeButtons.forEach(function (btn) {
          var badge = btn.closest(".collection-dynamic-filters__active-badge");
          if (!badge) return;

          var filterType = badge.dataset.filterType;
          var filterParam = badge.dataset.filterParam;
          var filterValue = badge.dataset.filterValue;
          var filterParamMin = badge.dataset.filterParamMin;
          var filterParamMax = badge.dataset.filterParamMax;

          var newBtn = btn.cloneNode(true);
          btn.parentNode.replaceChild(newBtn, btn);

          newBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var currentBadge = newBtn.closest(".collection-dynamic-filters__active-badge");
            if (!currentBadge) return;

            var currentFilterType = currentBadge.dataset.filterType;
            var currentFilterParam = currentBadge.dataset.filterParam;
            var currentFilterValue = currentBadge.dataset.filterValue;
            var currentFilterParamMin = currentBadge.dataset.filterParamMin;
            var currentFilterParamMax = currentBadge.dataset.filterParamMax;

            if (currentFilterType === "price_range" && currentFilterParamMin && currentFilterParamMax) {
              var priceRange = document.querySelector('.collection-dynamic-filters__price-range[data-filter-id*="preco"]');
              if (priceRange) {
                var filterId = priceRange.dataset.filterId;
                self.clearPriceFilter(filterId, false);
              }
            } else if (currentFilterParam && currentFilterValue) {
              var allCheckboxes = document.querySelectorAll('input[type="checkbox"]');
              var found = false;
              allCheckboxes.forEach(function (checkbox) {
                if (checkbox.name === currentFilterParam && checkbox.value === currentFilterValue) {
                  checkbox.checked = false;
                  checkbox.dataset.userState = "unchecked";
                  var label = checkbox.closest("label");
                  if (label) label.classList.remove("is-active");
                  found = true;
                }
              });
              if (found) self.handleFilterChange();
            }
          });
        });
      },
    };

    return CollectionDynamicFilters;
  })();

  function initCollectionDynamicFilters() {
    var container = document.querySelector("#CollectionDynamicFilters");
    if (container) {
      if (window.collectionDynamicFilters) window.collectionDynamicFilters = null;
      window.collectionDynamicFilters = new theme.CollectionDynamicFilters(container);
    }
  }

  document.addEventListener("DOMContentLoaded", initCollectionDynamicFilters);

  document.addEventListener("shopify:section:load", function (event) {
    if (
      event.detail.sectionId &&
      (event.detail.sectionId.includes("main-collection") || event.detail.sectionId.includes("collection-template"))
    ) {
      setTimeout(initCollectionDynamicFilters, 100);
    }
  });
  document.addEventListener("collection:reloaded", function () {

    setTimeout(initCollectionDynamicFilters, 100);
  });
})();
